import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { CreateProductSchema } from '@app/models/products';
import Api from '@app/services/api';

interface IProps {
  data: CreateProductSchema;
}

export const useCreateProductQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ data }: IProps) => {
      await Api.products.postProduct(data);
      await client.invalidateQueries(['getProducts']);
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
    onSuccess: async () => {
      await client.invalidateQueries(['getProducts']);
      message.open({
        type: 'success',
        content: commonT.t('dataAddSuccess'),
      });
    },
  });
};
